import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import DateHelpers from "../Helper/DateHelpers";
import '../Styles/EventReporting.scss';


function EventReporting() {

   const location = useLocation();
   const props = location.state;
   console.log("props", props)
   const columns = Object.keys(props[0]);
   console.log("columns", columns)

   function tableToCSV() {

      // Variable to store the final csv data
      let csv_data = [];

      // Get each row data
      let rows = document.getElementsByTagName('tr');
      for (let i = 0; i < rows.length; i++) {

         // Get each column data
         let cols = rows[i].querySelectorAll('td,th');

         // Stores each csv row data
         let csvrow = [];
         for (let j = 0; j < cols.length; j++) {

            // Get the text data of each cell of
            // a row and push it to csvrow
            csvrow.push(cols[j].innerHTML);
         }

         // Combine each column value with comma
         csv_data.push(csvrow.join(","));
      }
      // Combine each row data with new line character
      csv_data = csv_data.join('\n');

      downloadCSVFile(csv_data);
      /* We will use this function later to download
      the data in a csv file downloadCSVFile(csv_data);
      */
   }

   function downloadCSVFile(csv_data) {

      // Create CSV file object and feed our
      // csv_data into it
      let CSVFile = new Blob([csv_data], { type: "text/csv" });

      // Create to temporary link to initiate
      // download process
      let temp_link = document.createElement('a');

      // Download csv file
      temp_link.download = "CampReport.csv";
      let url = window.URL.createObjectURL(CSVFile);
      temp_link.href = url;

      // This link should not be displayed
      temp_link.style.display = "none";
      document.body.appendChild(temp_link);

      // Automatically click the link to trigger download 
      temp_link.click();
      document.body.removeChild(temp_link);
   }

   return (
      <div className="EventReportingContainer">
         <div className="EventReportingContent">
            {props != null &&

               <div className="EventReportingTable">
                  <table>
                     <thead>
                        <tr>
                            <th>
                              Number
                           </th>
                           <th>
                              Last Name
                           </th>
                           <th>
                              First Name
                           </th>
                           <th>
                              Age
                           </th>
                           <th>
                              Gender
                           </th>
                           <th>
                              City
                           </th>
                           <th>
                              State
                           </th>
                           <th>
                              Zip
                           </th>
                           <th>
                              Email 
                           </th>
                           <th>
                              Phone
                           </th>
                           <th>
                              Buddy Name
                           </th>
                           <th>
                              Authorized Individuals
                           </th>
                        </tr>
                     </thead>
                     <tbody>
                        {props.map((item, index) => (
                           <tr key={index}>
                              <td>
                                 {item.row_num}
                              </td>
                              <td>
                                 {item.last_name}
                              </td>
                              <td>
                                 {item.first_name}
                              </td>
                              <td>
                                 {DateHelpers.determineCamperAgeInYears(item.birth_date)}
                              </td>
                              <td>
                                 {item.gender}
                              </td>
                              <td>
                                 {item.mail_city}
                              </td>
                              <td>
                                 {item.mail_state}
                              </td>
                              <td>
                                 {item.mail_zip}
                              </td>
                              <td>
                                 {item.account_email}
                              </td>
                              <td>
                                 {item.account_phone}
                              </td>
                              <td>
                                 {item.buddy_first_name != null ? item.buddy_first_name + " " + item.buddy_last_name : "no buddy selected"}
                              </td>
                              <td>
                                 {item.day_camp_authorized_individual_one_first_name === null ? " "
                                    : item.day_camp_authorized_individual_one_first_name + " "}
                                 {item.day_camp_authorized_individual_one_last_name === null ? " "
                                    : item.day_camp_authorized_individual_one_last_name + ", "}
                                 {item.day_camp_authorized_individual_two_first_name === null ? " "
                                    : item.day_camp_authorized_individual_two_first_name + " "}
                                 {item.day_camp_authorized_individual_two_last_name === null ? " "
                                    : item.day_camp_authorized_individual_two_last_name + ", "}
                                 {item.day_camp_authorized_individual_three_first_name === null ? " "
                                    : item.day_camp_authorized_individual_three_first_name + " "}
                                 {item.day_camp_authorized_individual_three_last_name === null ? " "
                                    : item.day_camp_authorized_individual_three_last_name + ", "}
                                 {item.day_camp_authorized_individual_four_first_name === null ? " "
                                    : item.day_camp_authorized_individual_four_first_name + " "}
                                 {item.day_camp_authorized_individual_four_last_name === null ? " "
                                    : item.day_camp_authorized_individual_four_last_name + ", "}
                                 {item.day_camp_authorized_individual_five_first_name === null ? " "
                                    : item.day_camp_authorized_individual_five_first_name + " "}
                                 {item.day_camp_authorized_individual_five_last_name === null ? " "
                                    : item.day_camp_authorized_individual_five_last_name + ", "}
                                 {item.day_camp_authorized_individual_six_first_name === null ? " "
                                    : item.day_camp_authorized_individual_six_first_name + " "}
                                 {item.day_camp_authorized_individual_six_last_name === null ? " "
                                    : item.day_camp_authorized_individual_six_last_name}
                              </td>
                           </tr>
                        ))}
                     </tbody>
                  </table>
                  <button type="button" onClick={() => tableToCSV()}>
                     download CSV
                  </button>
               </div>
            }
            { props == null &&
               <div>
                  No reporting available.
               </div>
            }
         </div>
      </div>
   )

}
export default EventReporting